import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import t from 'ember-intl/helpers/t';
import type { Signature as ForcProviderBaseSignature } from 'parog-web/components/forc/provider/base';

interface Signature {
  Args: {
    form: ForcProviderBaseSignature['Blocks']['default'][0];
  };
}
export default class MiciBaseConsultFormHasFistulas extends Component<Signature> {
  clearChangeset = () => {
    if (!this.args.form.changeset.get('hasFistulas')) {
      this.args.form.changeset.set('fistulasPain', undefined);
      this.args.form.changeset.set('fistulasEmbarrassment', undefined);
      this.args.form.changeset.set('fistulasFlow', undefined);
      this.args.form.changeset.set('fistulasPainSkin', undefined);
      this.args.form.changeset.set('fistulasMovement', undefined);
    }
  };

  <template>
    <@form.FieldsRadioGroup
      @propertyName='hasFistulas'
      @title={{t 'mici-form.hasFistulas.long' htmlSafe=true}}
      as |Group|
    >
      <Group.FieldRadio @value={{true}} @label='Oui' />
      <Group.FieldRadio
        @value={{false}}
        @label='Non'
        {{on 'click' this.clearChangeset}}
      />
    </@form.FieldsRadioGroup>
  </template>
}
